/* eslint-disable max-lines */
/* eslint-disable react-func/max-lines-per-function */
import { YsfConfig } from 'common-package/src/types';
import { awaitYsfOpen, encodeNextUrl, getCurrentMainPortalOrigin } from 'common-package/src/utils';
import { LANG_LOCAL_STORAGE_KEY, SubPackageSlugEnum, ZH } from '@yaotai/common-utils';
import { RouterConfigEnum } from './common';

export const contactMes = {
  phone: '(0571)89852163 转 21951',
  email: 'fuxi@service.netease.com',
};

export const getHeaderNav = ({ isMain }: { isMain?: boolean } = { isMain: true }) => {
  return isMain
    ? [
        RouterConfigEnum.Home,
        RouterConfigEnum.Scenario,
        RouterConfigEnum.CoreTechnology,
        RouterConfigEnum.EcologicalCooperation,

        // 主线特有
        RouterConfigEnum.DatabaseListNews,
        RouterConfigEnum.Database,
        RouterConfigEnum.HelpCenterLabel,

        RouterConfigEnum.AboutUs,
      ]
    : [
        RouterConfigEnum.Home,
        RouterConfigEnum.Scenario,
        RouterConfigEnum.CoreTechnology,
        RouterConfigEnum.EcologicalCooperation,
        RouterConfigEnum.AboutUs,
      ];
};

export const getFooterNav = ({ isMain }: { isMain?: boolean } = { isMain: true }) => {
  return isMain
    ? [
        RouterConfigEnum.Yaotai,
        RouterConfigEnum.Scenario,
        RouterConfigEnum.EcologicalCooperation,
        RouterConfigEnum.AboutUs,
        RouterConfigEnum.Consult,
        // 主线特有
        RouterConfigEnum.Database,
        RouterConfigEnum.HelpCenterLabel,
      ]
    : [
        RouterConfigEnum.Yaotai,
        RouterConfigEnum.Scenario,
        RouterConfigEnum.EcologicalCooperation,
        RouterConfigEnum.AboutUs,
        RouterConfigEnum.Consult,
      ];
};

export type NavListItem = {
  action?: Function;
  checkLogin?: boolean;
  highlights?: string[];
  href?: string;
  label: string;
  menu?: NavListItem[];
  menuHide?: boolean;
  noFollow?: boolean; // 用于是否需要被检索 seo 的判断
  useHref?: boolean;
  hidden?: boolean; // 主要用户非主线的隐藏
};

/*
 * 补充前请注意：
 * highlights 数组表示哪些路由下 当前导航标签具有紫色下划线标识 参考数字活动 digitalActivity 项，注意路由需要加 '/' 开头
 * menuHide 表示头部导航栏导航项 hover 上时不出现菜单 该项用于区分头部导航栏和底部导航栏的共有项，一般可以不用管，按照当前即可
 */

export const getNavList = ({ isMain }: { isMain: boolean }): NavListItem[] => {
  const NAV_LIST: NavListItem[] = [
    {
      label: RouterConfigEnum.Home,
      href: '/',
      highlights: ['/'],
    },
    {
      label: RouterConfigEnum.Yaotai,
      highlights: [],
      href: '',
      menu: [
        {
          // 核心技术
          label: RouterConfigEnum.CoreTechnology,
          href: `/${RouterConfigEnum.CoreTechnology}`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.DownloadWay,
          href: `/${RouterConfigEnum.DownloadWay}/`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.EventEntrance,
          noFollow: true,
          href: `/${RouterConfigEnum.EventEntrance}`,
        },
        {
          label: RouterConfigEnum.CustomerService,
          noFollow: true,
          href: '',
          action: async (options?: YsfConfig) => {
            const { uid, phone, email } = options?.userInfo || {};
            await awaitYsfOpen({
              uid: uid || '',
              name: '',
              email: email || '',
              mobile: phone || '',
              data: JSON.stringify([{ key: 'activity', value: '', label: '活动名称' }]),
            });
          },
        },
      ],
    },
    {
      label: RouterConfigEnum.Scenario,
      highlights: [
        `/${RouterConfigEnum.Scene}`,
        `/${RouterConfigEnum.SceneCasePre}`,
        `/${RouterConfigEnum.AnnualMeeting}`,
        `/${RouterConfigEnum.Museum}`,
        `/${RouterConfigEnum.CorporateSpace}`,
      ],
      href: `/${RouterConfigEnum.Scene}/`,
      menu: [
        {
          label: RouterConfigEnum.AcademicConference,
          href: `/${RouterConfigEnum.SceneCaseLearning}/`,
        },
        {
          label: RouterConfigEnum.IndustrySummit,
          href: `/${RouterConfigEnum.SceneCaseIndustrySummit}/`,
        },
        {
          label: RouterConfigEnum.AutoShow,
          href: `/${RouterConfigEnum.SceneCaseCarShow}/`,
        },
        {
          label: RouterConfigEnum.VirtualActivity,
          href: `/${RouterConfigEnum.SceneCaseArtShow}/`,
        },
        // isMain
        //   ? {
        //       label: RouterConfigEnum.AnnualMeeting,
        //       href: `/${RouterConfigEnum.AnnualMeeting}/`,
        //     }
        //   : ({} as NavListItem),
        {
          label: RouterConfigEnum.Museum,
          href: `/${RouterConfigEnum.SceneCaseMuseum}/`,
        },
        {
          label: RouterConfigEnum.CorporateSpace,
          href: `/${RouterConfigEnum.SceneCaseCorporateSpace}/`,
        },
      ],
    },
    {
      // 核心技术
      label: RouterConfigEnum.CoreTechnology,
      href: `/${RouterConfigEnum.CoreTechnology}`,
      highlights: [`/${RouterConfigEnum.CoreTechnology}`],
      // noFollow: true,
    },
    {
      label: RouterConfigEnum.EcologicalCooperation,
      highlights: [`/${RouterConfigEnum.AgentPage}/`],
      href: `/${RouterConfigEnum.AgentPage}/`,
      menuHide: true,
      // noFollow: true,
      menu: [
        {
          label: RouterConfigEnum.AuthorizedAgent,
          href: `/${RouterConfigEnum.AgentPage}/`,
        },
      ],
    },
    {
      label: RouterConfigEnum.DatabaseListNews,
      href: `/${RouterConfigEnum.SeoPostSlug}/`,
      noFollow: true,
      useHref: true,
    },

    {
      label: RouterConfigEnum.ActivityCenter,
      // noFollow: true,
      highlights: [`/${RouterConfigEnum.ActivityCenter}`, `/${RouterConfigEnum.EventEntrance}`],
      href: `/${RouterConfigEnum.ActivityCenter}/`,
    },
    {
      label: RouterConfigEnum.Database,
      noFollow: true,
      highlights: [RouterConfigEnum.SeoMaterialSlug, RouterConfigEnum.News, `/${RouterConfigEnum.SeoPostSlug}/`],
      href: `/${RouterConfigEnum.SeoMaterialSuccessfulCase}`,
      useHref: true,
      // menuHide: true,
      menu: [
        {
          label: RouterConfigEnum.SuccessCase,
          href: `/${RouterConfigEnum.SeoMaterialSuccessfulCase}`,
          noFollow: true,
          useHref: true,
        },
        {
          label: RouterConfigEnum.IndustryReports,
          href: `/${RouterConfigEnum.SeoMaterialIndustrialReport}`,
          noFollow: true,
          useHref: true,
        },
        {
          label: RouterConfigEnum.Daka,
          href: `/${RouterConfigEnum.SeoMaterialDaka}`,
          noFollow: true,
          useHref: true,
        },
      ],
    },
    {
      label: RouterConfigEnum.AboutUs,
      noFollow: true,
      highlights: [
        `/${RouterConfigEnum.KnowUs}`,
        `/${RouterConfigEnum.ContactUsActivity}`,
        `/${RouterConfigEnum.ContactUsCooperation}`,
        `/${RouterConfigEnum.ContactUsAgent}`,
      ],
      href: '',
      menu: [
        {
          label: RouterConfigEnum.UnderstandUs,
          href: `/${RouterConfigEnum.KnowUs}/`,
          noFollow: true,
        },

        {
          label: RouterConfigEnum.ContactUsPage,
          // 非主线外链形式跳转到无头的咨询页面
          href: isMain
            ? `/${RouterConfigEnum.ContactUsActivity}`
            : `${getCurrentMainPortalOrigin()}/${RouterConfigEnum.CommonContactActivity}`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.Question,
          href: `/${RouterConfigEnum.SeoQuestionSlug}`,
          noFollow: true,
          useHref: true,
          hidden: !isMain,
        },
      ],
    },
    {
      label: RouterConfigEnum.Consult,
      noFollow: true,
      highlights: [],
      href: '',
      menu: [
        {
          label: RouterConfigEnum.ActivityConsult,
          href: `/${RouterConfigEnum.ContactUsActivity}/`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.AgentPage,
          href: `/${RouterConfigEnum.ContactUsAgent}/`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.Media,
          href: `/${RouterConfigEnum.ContactUsCooperation}`,
          noFollow: true,
        },
        {
          label: RouterConfigEnum.Advice,
          href: `/${RouterConfigEnum.ContactUsCooperation}`,
          noFollow: true,
        },
      ],
    },
    {
      label: RouterConfigEnum.HelpCenterLabel,
      noFollow: true,
      highlights: [`/${RouterConfigEnum.HelpCenter}`, `/${RouterConfigEnum.SeoQuestionSlug}/`],
      href: isMain
        ? `/${RouterConfigEnum.HelpCenter}/`
        : `${getCurrentMainPortalOrigin()}/${RouterConfigEnum.HelpCenter}/`,
      menuHide: true,
      checkLogin: false,
      menu: [
        {
          label: RouterConfigEnum.Manual,
          noFollow: true,
          checkLogin: false,
          href: 'https://yaotai.163.com/docs/zh/',
        },
        {
          label: RouterConfigEnum.ProductTraining,
          noFollow: true,
          checkLogin: false,
          href: 'https://docs.popo.netease.com/drive/folder/2cb9217fbf2441b784eca04fdaca1a70',
        },
        {
          label: RouterConfigEnum.VideoTraining,
          href: isMain
            ? `/${RouterConfigEnum.HelpCenter}/`
            : `${getCurrentMainPortalOrigin()}/${RouterConfigEnum.HelpCenter}/`,
          noFollow: true,
          checkLogin: false,
        },
        // {
        //   label: RouterConfigEnum.Question,
        //   noFollow: true,
        //   href: `/${RouterConfigEnum.SeoQuestionSlug}`,
        //   useHref: true,
        // },
      ],
    },
  ];
  return NAV_LIST;
};

export const COOPERATE_MAIL = {
  MEDIA: 'pr-yaotai@service.netease.com',
  FUND: 'ir-yaotai@service.netease.com',
  ADVICE: 'feedback-yaotai@service.netease.com',
};

export const FEEDBACK_MAIL = 'feedback-yaotai@service.netease.com';
export const LOGIN_TO_HELP = `${window.location.origin}/${SubPackageSlugEnum.Center}/login?next=${encodeNextUrl(`${
  window.location.origin
}/${window.localStorage.getItem(LANG_LOCAL_STORAGE_KEY) || ZH}
`)}/${RouterConfigEnum.HelpCenter}`;

export const DEVICES = ['web', 'wechat', 'pc', 'app'];

// 隐藏「联系我们」页面顶部的tab
export const HIDE_TAB_LIST = ['marketing-page'];

export * from './common';
export * from './help';
export * from './content';
export * from './scene';
export * from './material';
export * from './contact';
export * from './personalize';
export * from './immersion';
export * from './technology';
export * from './consult';
export * from './home';
export * from './recommend';
